export const translate = (key, values = []) => {
    let translation = window.__litium.translation[key] || key

    if(values.length === 0){
        return translation.replace(/{(.*?)}/g, "");
    }
    
    return translation.replace(/{(.*?)}/g, (match, offset) => values[offset]);
};